;$(function () {
 const $navigator = $('.c-navigator');

 $('[data-navigator]', $navigator).on('click', function (e) {
   e.preventDefault();

   const showBlock = $(this).data('navigator');
   history.replaceState('', '', $(this).attr("href") );
   $(`[data-navigator-block]`).removeClass('is-active');
   $(`[data-navigator-block=${showBlock}]`).addClass('is-active');
 })

});
